import React, { useRef, useState, useEffect } from "react";
import { MagnifyingGlass } from "phosphor-react";

// style imports
import "../Input/Input.css";
import "./SearchBox.css";
import "../MultiSelect/MultiSelect.css";

const SearchBox = ({ label, id, onChange, initialValue, keyName, 
    list, loading,error, std}) => {
  // Create a ref to manage the input focus
  const inputRef = useRef(null);

  // set for show result list
  const [show, setShow] = useState(false);
  const [inputValue, setInputValue] = useState(initialValue); 
  const [tags, setTags] = useState(false)     

  // change in initial value
  useEffect(() => {    
    setInputValue(initialValue || ""); 
    setTags(!!initialValue);       
  }, [initialValue]);     

  // Focus the input field when label is clicked
  const handleEditClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setShow(!!value);
    setTags(value.trim() !== "");
  };

  // Handle item selection
  const handleItemClick = (item) => {
    setInputValue(item[keyName]); // Update input field
    setShow(false); // Hide the list
    onChange?.(item); // Send the selected item to parent
    setTags(true)
  };


  // list of items
  const ListOfItem = () => {
    if (loading)
      return (
        <div className="mues_row_center mues_grey_I select_option_container">
          Loading
        </div>
      );
    if (error)
      return (
        <div className="mues_row_center mues_grey_I select_option_container">
          Error
        </div>
      );
    // Filter items based on the search query
    const filteredList = list.filter((item) =>
      item[keyName]?.toLowerCase().includes(inputValue.toLowerCase())
    );
    
    if (filteredList.length === 0) {
      return (
        <div className="mues_row_center mues_grey_I select_option_container">
          No results found
        </div>
      );
    }
    return (
      <div className="select_option_container">
        {filteredList?.map((item) => (
          <div className={`mues_row_flex select_option_card
          mues_column_gap_8`} key={item.id} onClick={() => handleItemClick(item)}>
            <div className={`mues_logo_search_box mues_row_center ${item.global_id==null? 'yellow_status_btn':'green_status_btn'}`}>
              {item.global_id==null? 'M':'G'}
            </div>
            {keyName && (
              <p className="mues_grey_I mues_font_weight_600 mues_one_line_clamp">
                {item[keyName]}
              </p>
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className={`form-input search_box_container ${tags ? 'topic_box_container':'no_topic_box'}`} 
    onClick={handleEditClick}>
      {tags && <div className={`mues_logo_search_box 
      mues_row_center topic_tag_box ${std ? 'yellow_status_btn':'green_status_btn'}`}>
          {std ? 'M':'G'}
      </div>}
      <input type="text" id={id} value={inputValue}
      placeholder={label} onChange={handleInputChange} onFocus={() => setShow(true)}
      ref={inputRef} onBlur={() => setTimeout(() => setShow(false), 400)} autoComplete="off"/>
      <label htmlFor={label}>{label}</label>
      <MagnifyingGlass className="mues_wrapper_icon mues_grey_II" weight="fill"/>
      {show && <ListOfItem />}
    </div>  
  );
};

export default SearchBox;
